import { jsx as _jsx } from "react/jsx-runtime";
import { RequireAuth } from "@/components/RequireAuth/RequireAuth";
import { useMemo } from "react";
import { Route, Routes } from "react-router-dom";
import { appRoutes } from "./routes";
export const RouterManager = () => {
    const routes = useMemo(() => appRoutes.map(({ path, component: RouteComponent, requiresAuth }) => (_jsx(Route, { path: path, element: requiresAuth ? (_jsx(RequireAuth, { children: _jsx(RouteComponent, {}) })) : (_jsx(RouteComponent, {})) }, path))), []);
    return _jsx(Routes, { children: routes });
};
